(() => {
  if (!window.YoLinkUrlContext) return; // Keep native search when the enhancement dependency is missing.
  const root = document.querySelector('[data-yl-search-route]');
  if (!root) return;

  const current = new URL(window.location.href);
  const searchRoute = new URL(root.dataset.searchUrl || '', current.origin);
  const catalogRoute = new URL(root.dataset.catalogUrl || '', current.origin);
  if (searchRoute.origin !== current.origin || catalogRoute.origin !== current.origin) return;
  if (current.pathname.replace(/\/$/, '') !== searchRoute.pathname.replace(/\/$/, '')) return;

  const preserve = destination => {
    window.YoLinkUrlContext.preserve(destination, current);
    // Catalog state belongs only on catalog destinations, not guide/manual URLs.
    if (destination.origin === current.origin && destination.pathname === catalogRoute.pathname) {
      for (const key of ['category', 'family', 'purchase', 'hub', 'sort', 'availability', 'new_releases']) {
        const values = current.searchParams.getAll(key).filter(value =>
          key === 'availability' ? ['all', 'in-stock'].includes(value) : key === 'new_releases' ? value === '1' : true);
        if (!values.length) continue;
        destination.searchParams.delete(key);
        for (const value of values) destination.searchParams.append(key,
          ['category', 'purchase', 'hub'].includes(key)
            ? value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : value);
      }
    }
    return destination;
  };

  // Same-origin navigation retains a Shopify preview cookie; carry an explicit preview query too.
  root.querySelectorAll('[data-yl-search-products],[data-yl-search-guides],[data-yl-manual-search]').forEach(link => {
    const destination = new URL(link.getAttribute('href'), current.origin);
    if (destination.origin === current.origin) link.href = preserve(destination).href;
  });
  const form = root.querySelector('[data-yl-support-search-form]');
  if (form) {
    for (const [key, value] of window.YoLinkUrlContext.entries(current)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.append(input);
    }
  }

  const query = current.searchParams.get('q')?.trim();
  if (!query) return;
  const types = current.searchParams.getAll('type').flatMap(value => value.split(',')).map(value => value.trim().toLowerCase()).filter(Boolean);
  if (types.length && !types.includes('product')) return; // Native page/article search stays here.

  const localePrefix = searchRoute.pathname.replace(/\/search\/?$/, '');
  if (catalogRoute.pathname.replace(/\/$/, '') !== `${localePrefix}/collections/all`) return;
  if (catalogRoute.pathname === current.pathname) return;
  catalogRoute.search = '';
  catalogRoute.hash = '';
  catalogRoute.searchParams.set('q', query);
  window.location.replace(preserve(catalogRoute).href);
})();
